// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8809 ? "700d6c82" : chunkId) + "." + {"964":"39cc18d270385ff2","1510":"7c4068193037eca3","2868":"11130d740e83363b","8083":"b7cff3232b863246","8809":"ab9891781ff97b65"}[chunkId] + ".js";
};